import { Component, OnInit } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';

import { AccountService } from 'src/app/core/services/account.service';
import { UserAccountNotificationSettingsDto } from 'src/app/core/dtos/dto';
import { TelInputDto } from 'src/app/core/dtos/tel-input-model';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { SmsHelper } from 'src/app/core/services/helpers/smsHelper';

@Component({
  selector: 'app-notification-settings',
  templateUrl: './notification-settings.component.html',
  styleUrls: ['./notification-settings.component.scss']
})
export class NotificationSettingsComponent implements OnInit {

  formGroup: FormGroup;

  constructor(
    private accountService: AccountService,
    private toastService: HotToastService,
    private formBuilder: FormBuilder,
    private smsHelper: SmsHelper
  ) { }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      allowSMSNotifications: [false],
      smsPhoneNumber: ['']
    });

    this.getNotificationSettings();
  }

  getNotificationSettings() {
    this.accountService.getNotificationSettings()
      .subscribe(
        result => {
          this.formGroup.patchValue({
            allowSMSNotifications: result.content.allowSMSNotifications,
            smsPhoneNumber: result.content.smsPhoneNumber
          });
        },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
        });
  }

  saveNotificationSettings(dto: UserAccountNotificationSettingsDto) {
    this.accountService.saveNotificationSettings(dto)
      .subscribe(
        () => {
          this.toastService.success("Successfully changed notification settings.");
        },
        (error: HttpErrorResponse) => {
          if (error.status !== 401) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            if (errorMessage?.reasons) {
              errorMessage.reasons.forEach(reasons => {
                this.toastService.warning(reasons.errorMessage);
              });
            }
            else {
              this.toastService.warning("Unable to save notification settings");
            }
          }
        });
  }

  onSubmit() {
    let convertedTelInput = this.formGroup.controls.smsPhoneNumber.value as TelInputDto;
    if (!this.formGroup.controls.allowSMSNotifications.value) {
      convertedTelInput = null;
    }
    const dto: UserAccountNotificationSettingsDto = {
      allowSMSNotifications: this.formGroup.controls.allowSMSNotifications.value,
      smsPhoneNumber: convertedTelInput ? this.smsHelper.formatPhoneNumber(convertedTelInput.e164Number) : null,
    };
    this.saveNotificationSettings(dto);
  }
}
